// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { searchOnlineCoursesEpic } from './searchOnlineCoursesEpic';
import { searchOnlineCoursesKeywordEpic } from './searchOnlineCoursesKeywordEpic';
import { searchLabsEpic } from './searchLabsEpic';
import { searchLabsKeywordEpic } from './searchLabsKeywordEpic';
import { searchChallengesEpic } from './searchChallengesEpic';
import { searchChallengesKeywordEpic } from './searchChallengesKeywordEpic';
import { searchExamsEpic } from './searchExamsEpic';
import { searchExamsKeywordEpic } from './searchExamsKeywordEpic';

export default [
  searchLabsEpic,
  searchLabsKeywordEpic,
  searchChallengesEpic,
  searchChallengesKeywordEpic,
  searchOnlineCoursesEpic,
  searchOnlineCoursesKeywordEpic,
  searchExamsEpic,
  searchExamsKeywordEpic
]
